var $0bc56cee3275bcaa$exports = {};
$0bc56cee3275bcaa$exports = {
    "close": `Zapri`,
    "notifications": `Obvestila`
};


export {$0bc56cee3275bcaa$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
